const modules = {
    hero: {
        title: 'Landing Pages',
        body: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean cursus auctor ligula, et scelerisque diam tempor ac.
      Nunc justo risus, consequat in aliquam sed, pulvinar ut arcu. Duis odio risus, bibendum in sollicitudin nec`,
    },
    cta1: {
        title: 'Heading 1',
        body: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus interdum lectus nisi, ut tempus odio interdum sed.
      Maecenas consequat suscipit commodo. Pellentesque venenatis metus vel dapibus porta.`,
        btn: 'Button Text',
        bg: '/images/module-cta1.jpg',
    },
    cta2: {
        card1: {
            img: '/images/cta2-card-left.png',
            title: 'Heading 1',
            body: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus eget lobortis enim, quis pellentesque sapien.
          Nullam quis iaculis lorem, eu tempus elit. Maecenas molestie sapien vehicula augue tincidunt, et tristique libero
          congue. Nunc interdum viverra mi vel ullamcorper. Cras et dapibus erat, ultrices pretium massa. Integer bibendum
          sed nunc at interdum. Morbi porta ligula ac eros imperdiet, vel mollis arcu malesuada. Class aptent taciti sociosqu
          ad litora torquent per conubia nostra, per inceptos himenaeos.`,
            btn: 'Button Text',
        },
        card2: {
            title: 'Heading 1',
            body: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus eget lobortis enim, quis pellentesque sapien.
          Nullam quis iaculis lorem, eu tempus elit.`,
            btn: 'Button Text',
            bg: '/images/cta2-card-right.png',
        },
    },
    blockContent: {
        title: 'Heading 1',
        body: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus interdum lectus nisi, ut tempus odio interdum sed.
      Maecenas consequat suscipit commodo. Phasellus interdum`,
        btn: 'Button Text',
    },
    blockBG: {
        bg: '/images/module-block-bg.jpg',
        img: '/images/module-block-img.jpg',
    },
    ctaFull1: {
        title: 'Heading 1',
        body: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus eget lobortis
  enim, quis pellentesque sapien. Nullam quis iaculis lorem, eu tempus elit. Maecenas molestie sapien vehicula augue tincidunt,
  et tristique libero congue. Nunc interdum viverra mi vel ullamcorper. Cras et dapibus erat, ultrices pretium massa. Integer
  bibendum sed nunc at interdum. Morbi porta ligula ac eros imperdiet, vel mollis arcu malesuada. Class aptent taciti sociosqu
  ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        btn: 'Button Text',
        flip: false,
        img: '/images/module-block-img.png',
    },
    ctaFull2: {
        title: 'Heading 1',
        body: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus eget lobortis
  enim, quis pellentesque sapien. Nullam quis iaculis lorem, eu tempus elit. Maecenas molestie sapien vehicula augue tincidunt,
  et tristique libero congue. Nunc interdum viverra mi vel ullamcorper. Cras et dapibus erat, ultrices pretium massa. Integer
  bibendum sed nunc at interdum. Morbi porta ligula ac eros imperdiet, vel mollis arcu malesuada. Class aptent taciti sociosqu
  ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        btn: 'Button Text',
        flip: true,
        img: '/images/module-block-img.png',
    },
    pillars3: {
        title: 'Heading 1',
        pillar: {
            title: 'Header 2',
            body: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus interdum lectus nisi, ut tempus odio interdum sed.
        Maecenas consequat suscipit commodo. Phasellus interdum`,
            btn: 'Button Text',
        },
        img1: '/images/module-pillar.jpg',
        img2: '/images/module-block-img.png',
    },
    pillars4: {
        title: 'heading 1',
        pillar: {
            title: 'Heading 3',
            body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus interdum lectus nisi.',
            img: '/images/module-block-img.png',
        },
        img1: '/images/module-pillar.jpg',
    },
};

export default modules;



// WEBPACK FOOTER //
// ./app/config/context/modules/modules.js